import React from 'react'
import Layout from '../DashboardLayout'

const TransmitWallet = () => {
  return (
    <Layout>TransmitWallet</Layout>
  )
}

export default TransmitWallet